export { default as I18nMarkdown } from './I18nMarkdown';
